import { Grid, Stack } from "@mui/material";
import Spinner from "./images/spinner.png";
import styled from "styled-components";

const PageTitle = styled.h2`
  margin-top: 0.5rem;
  margin-bottom: 0rem;
  letter-spacing: -1px;
  align-items: center;
  text-align: center;
`;

const PageDescription = styled.p`
  margin-top: 1rem;
  margin-bottom: 0rem;
  align-items: center;
  text-align: center;
`;

export const RulesExecutionPage = () => {
  return (
    <Stack>
      <img
        src={Spinner}
        style={{ alignSelf: "center", paddingTop: "278px", paddingBottom: "16px" }}
        width="110"
        height="110"
        alt="Spinner"
      />
      <PageTitle>Aligning your subject</PageTitle>
      <PageDescription>
        LMSMorph is working its magic to automatically sort your content into the right sections.
      </PageDescription>
      <PageDescription>This process can take up to a minute.</PageDescription>
      <Grid
        tabIndex={-1}
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      ></Grid>
    </Stack>
  );
};
